import api from '@/api'

const namespaced = true

const state = {
  groups: []
}

const getters = {
  groups: state => state.groups
}

const mutations = {
  SET_GROUPS: (state, payload) => {
    state.groups = payload
  }
}

const actions = {
  async fetchGroups({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        ...payload,
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize
      }

      const { data } = await api.getGroups(payload.isActiveAll
        ? { is_active: true }
        : filter
      )

      switch (true) {
        case data.error: {
          commit('SET_GROUPS', [])
          commit('Table/SET_TOTAL_DATA', 0, { root: true })
          commit('Table/SET_TOTAL_PAGE', 1, { root: true })
          break
        }
        case payload.isActiveAll: {
          commit('SET_GROUPS', data)
          break
        }
        default: {
          commit('SET_GROUPS', data.data)
          commit('Table/SET_TOTAL_DATA', data.total, { root: true })
          commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
          break
        }
      }
    } catch (err) {
      throw err
    }
  },
  async postGroup(_, payload) {
    try {
      await api.postGroup(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async putGroup(_, payload) {
    try {
      const id = payload.id
      delete payload.id

      await api.putGroup(id, payload)
    } catch (err) {
      throw err
    }
  },
  async deleteGroup(_, payload) {
    try {
      await api.deleteGroup(payload)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
